import React from "react";

export const StatusIndicator = ({ isValid, isEmpty }) => {
  return (
    <div
      className={`transition-colors ${
        isValid
          ? "text-[#1BB66E]"
          : isEmpty
          ? "text-[#C9C9C9]"
          : "text-[#FF0000]"
      }`}
    >
      {isValid ? (
        <svg
          width="32"
          height="32"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle
            cx="20"
            cy="20"
            r="15.5"
            fill="currentColor"
            stroke="currentColor"
          />
          <path
            d="M27.1109 15.5556L17.3332 25.3333L12.8887 20.8889"
            stroke="white"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ) : isEmpty ? (
        <svg
          width="32"
          height="32"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="20" cy="20" r="15.5" fill="white" stroke="currentColor" />
          <path
            d="M27.1109 15.5556L17.3332 25.3333L12.8887 20.8889"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      ) : (
        <svg
          width="32"
          height="32"
          viewBox="0 0 40 40"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <circle cx="20" cy="20" r="15.5" stroke="currentColor" />
          <path
            d="M24.7505 26.397L19.8008 21.4473L14.851 26.397L13.2011 24.7471L18.1509 19.7973L13.2011 14.8476L14.851 13.1977L19.8008 18.1474L24.7505 13.1977L26.4004 14.8476L21.4507 19.7973L26.4004 24.7471L24.7505 26.397Z"
            fill="currentColor"
          />
        </svg>
      )}
    </div>
  );
};
